<template>
  <BudgetsLayout>
    <div v-if="displayBudgetBlock">
      <BudgetView/>
    </div>
    <BudgetEmptyBlock v-else/>
    <div>
      <BudgetNav/>
      <BudgetTransactions v-if="!!budgetSelected"
                          class="mt-12"
                          :budget="budgetSelected"/>
    </div>
  </BudgetsLayout>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import BudgetView from "@/components/cabinet/Money/Budgets/BudgetView";
import BudgetNav from "@/components/cabinet/Money/Budgets/BudgetsNav/BudgetNav";
import BudgetEmptyBlock from "@/components/cabinet/Money/Budgets/BudgetEmptyBlock";
import BudgetsLayout from "@/components/layouts/cabinet/BudgetsLayout";
import BudgetTransactions from "@/components/cabinet/Money/Budgets/BudgetTransactions";

export default {
  name: "TheBudgets",
  components: {BudgetTransactions, BudgetsLayout, BudgetNav, BudgetView, BudgetEmptyBlock},
  computed: {
    ...mapState('space/budgets', ['budgets', 'filters', 'budgetSelected']),
    displayBudgetBlock() {
      return !this.budgets.dirty && (this.budgets.data.expenses.length > 0 || this.budgets.data.incomes.length > 0)
    }
  },
  methods: {
    ...mapActions('space/budgets', ['getBudgets']),
    ...mapMutations('space/budgets', ['setSelectedBudget', 'setDateFilter'])
  },
  mounted() {
    this.setDateFilter(this.$moment().format('YYYY-MM'));
    this.$store.dispatch('space/accounts/getAccounts');
    this.$store.dispatch('space/accounts/getAccountGroups');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/tags/getTags');
    this.$store.dispatch('space/contractors/getContractors');
  },
  beforeDestroy() {
    this.setDateFilter(null);
  },
  watch: {
    'filters.date': {
      handler(newVal) {
        const date = newVal.split('-')
        const data = {
          year: date[0],
          month: date[1]
        }
        this.setSelectedBudget(null);
        this.getBudgets(data);
      }
    }
  }
}
</script>